import styled from 'styled-components';
import { Calendar } from './Calendar';
import { EventsTable } from './EventsTable';
import { useCalendarData } from './useCalendarData';

export const AdminLanding = () => {
  const {
    db,
    courseId,
    calendarRef,
    weeks,
    setWeeks,
    currentWeek,
    setCurrentWeek,
    allAssignments,
    isLoading,
  } = useCalendarData();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <PageWrapper>
      <Header>Code for Humanities · Admin</Header>
      <Content>
        <Calendar
          db={db}
          courseId={courseId}
          allAssignments={allAssignments}
          calendarRef={calendarRef}
          weeks={weeks}
          setWeeks={setWeeks}
          currentWeek={currentWeek}
          setCurrentWeek={setCurrentWeek}
        />
        <EventsTable weeks={weeks} />
      </Content>
    </PageWrapper>
  );
};

const PageWrapper = styled.div`
  background-color: white;
  font-family: Arial, sans-serif;
  color: #1a1a1a;
  min-height: 100vh;
`;

const Header = styled.header`
  border-bottom: 1px solid #ccc;
  padding: 1rem;
  text-align: center;
  background-color: black;
  color: #f5f5f5;
  font-size: 2rem;
  font-weight: 600;
`;

const Content = styled.main`
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
